export class TreeIcon {

    static create(id: string, icon: string, styleClass?: string, badgeCount?: number, clickable = false, onlyOnHover = false): TreeIcon {
        return new TreeIcon(id, icon, styleClass, badgeCount, clickable, onlyOnHover);
    }

    constructor (public id: string, public icon: string, public styleClass?: string, public badgeCount?: number, public clickable = false, public onlyOnHover = false) {
    }

}
